import { ExcelDataType } from 'xlsx';
import { GameDayModel } from '../../models/gameday-model';
import { ColumnDefinition } from '../../models/column';
import { ViewOrder } from '../mappers/gameDay-orders.transfomations';

export interface FormattedCell {
  value: number | string | Date;
  format: { t: ExcelDataType; z: string };
}

export interface TabSettings {
  name: string;
  header: string[];
  totals: FormattedCell[];
  table: FormattedCell[][];
  priority: number;
}

export interface ReportSettings {
  name: string;
  tabs: TabSettings[];
}

export interface RawReportsData {
  name: string;
  header: ColumnDefinition[];
  totals: any;
  data: any[];
  priority: number;
  orderMapper?: (order: GameDayModel.Order) => ViewOrder;
}

export enum ReportType {
  AllOrders = 'AllOrders',
  OrderMonitor = 'OrderMonitor',
  ManagersReport = 'ManagersReport',
  AccountsReport = 'AccountsReport'
}

export type ReportTypes = ReportType[];
